
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 86","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M100 26.317c0 24.264-13.682 44.639-34.238 51.24a35.113 35.113 0 01-12.635 2.365c-12.676 0-24.453-6.927-30.41-17.922-10.573 9.472-13.42 20.299-13.47 20.507C8.735 84.597 6.81 86 4.692 86c-.36 0-.728-.041-1.094-.124-2.518-.588-4.07-3.051-3.467-5.495 1.875-7.493 17.67-42.95 65.489-42.95 1.725.003 3.13-1.363 3.13-3.032 0-1.67-1.405-3.036-3.124-3.036-20.977 0-36.133 6.564-46.819 14.343.038-2.053.243-4.144.69-6.27 2.632-12.485 12.9-22.576 25.665-25.46 5.533-1.244 10.875-1.14 15.807 0 10.937 2.527 23.086-1.407 29.16-11.618 1.106-1.865 3.91-1.806 4.816.157C98.184 9.5 100 18.065 100 26.317z","fill":"currentColor"}})])
          )
        }
      }
    